import AppBar from "@mui/material/AppBar";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import React from "react";
import { ui } from "../../../interfaces/interfaces";
import useDebugInformation from "../../../hooks/useDebugInformation";
import { useAppSelector } from "@store/hooks";

const name = "ChargeRateTabHeader";

type A11yProps = {
  (index: number): {
    id: string
    "aria-controls": string
  }
}

const a11yProps: A11yProps = (index: number) => {
  return {
    id: `action-tab-${index}`,
    "aria-controls": `action-tabpanel-${index}`,
  };
}

const handleChange = (event: React.SyntheticEvent<Element, Event>, value: any) => {
  ui.RatesActiveTab = value
};

type ChargeRateTabHeaderProps = {
  parent: string
  affix: "Rates"
}

const ChargeRateTabHeader: React.FC<ChargeRateTabHeaderProps> = ({ parent, affix }) => {
  const ratesTabsList = useAppSelector(({ ui }) => ui.RatesTabsList)
  const ratesActiveTab = useAppSelector(({ ui }) => ui.RatesActiveTab)
  const jobTypeCode = useAppSelector(({ state }) => state.JobTypeCode)

  const debugName = `${parent}▷[${name}]`

  useDebugInformation(debugName, { ratesActiveTab, affix })
  return (
    <AppBar position="static" color="default">
      <Tabs
        sx={{ minHeight: "unset" }}
        value={ratesActiveTab} onChange={handleChange} indicatorColor="primary" textColor="primary" variant="fullWidth" aria-label="action tabs example">
        {jobTypeCode !== 'HBSMK'
          ? ratesTabsList.map((tab, idx) => (
            <Tab key={idx} label={`${tab.label}`}  {...a11yProps(idx)} sx={{ minHeight: "unset" }} />
          ))
          : [{
            label: "Benefits",
            name: "benefits",
          }].map((tab, idx) => (
            <Tab key={idx} label={`${tab.label}`}  {...a11yProps(idx)} sx={{ minHeight: "unset" }} />
          ))}
      </Tabs>
    </AppBar>
  )
}

ChargeRateTabHeader.displayName = name;


export default React.memo(ChargeRateTabHeader)
